"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beginExport = beginExport;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const date_fns_1 = require("date-fns");
const EXPORT_STATUS_CHECK_TIMEOUT = 3000;
function beginExport(exportClient, entity, type, selectedEntities, appliedFilters, orderBy, metadata) {
    const downloadFile = (exportId, fileName) => (0, DialogHelper_1.showProgressDialog)({
        title: 'Downloading. Please wait...',
        callback: (done) => exportClient
            .getResult(exportId)
            .then((result) => {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(new Blob([result.data], { type: result.contentType }));
            a.download = fileName;
            a.click();
        })
            .catch(() => {
            (0, DialogHelper_1.showErrorDialog)({
                title: 'Error downloading exported entities please try again',
            });
        })
            .finally(done),
    });
    let fetchExportStatusInterval;
    const handleExport = (exportId, done) => {
        const fetchExportStatus = () => {
            exportClient
                .get(exportId)
                .then((result) => {
                const isCompleted = result.status === 'completed';
                const isError = result.status === 'error';
                if (isCompleted || isError) {
                    window.clearInterval(fetchExportStatusInterval);
                    done();
                    if (isError) {
                        (0, DialogHelper_1.showErrorDialog)({
                            title: 'Something went wrong, please try again.',
                        });
                    }
                    if (isCompleted) {
                        const date = new Date(result.created);
                        const localDate = (0, date_fns_1.formatISO9075)(date, { format: 'extended', representation: 'complete' }).replace(' ', '-');
                        const fileName = `${entity}-export-${localDate}`;
                        (0, DialogHelper_1.showConfirmDialog)({
                            title: 'Export completed',
                            content: 'Entity export was completed, would you like to download the file?',
                            confirmLabel: 'Download',
                            onConfirm: () => downloadFile(exportId, fileName),
                        });
                    }
                }
            })
                .catch(() => {
                window.clearInterval(fetchExportStatusInterval);
                done();
                (0, DialogHelper_1.showErrorDialog)({
                    title: 'Something went wrong, please try again.',
                });
            });
        };
        if (!fetchExportStatusInterval) {
            fetchExportStatusInterval = window.setInterval(fetchExportStatus, EXPORT_STATUS_CHECK_TIMEOUT);
        }
    };
    const request = {
        entity: entity,
        type: type,
        orderBy: orderBy ? orderBy : undefined,
        metadata: metadata,
    };
    if (selectedEntities && selectedEntities.length > 0) {
        const selectedEntitiesFilter = {
            id: selectedEntities,
            op: 'in',
        };
        request.filter = [];
        if (appliedFilters) {
            request.filter.push(...appliedFilters);
        }
        request.filter.push(selectedEntitiesFilter);
    }
    else {
        request.filter = appliedFilters;
    }
    exportClient
        .post(request)
        .then((response) => {
        (0, DialogHelper_1.showProgressDialog)({
            title: 'Exporting...',
            callback: (done) => {
                handleExport(response.id, done);
            },
            fullWidth: true,
            maxWidth: 'sm',
        });
    })
        .catch(() => {
        (0, SnackbarHelper_1.handleErrorSnackbar)({
            message: 'Something went wrong, please try again.',
        });
    });
}
